/*
 * Copyright (c) 2026-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

/**
 * Why the sign-in screen is being shown.
 *
 * "You were signed out for being idle" is news, and news goes stale. It was
 * first carried in the URL, which outlived the thing it described — still
 * being announced hours later, and again on every later visit — and stripping
 * the parameter afterwards remounted the screen, so the notice flashed and
 * vanished before anyone could read it.
 *
 * So it lives here instead: one variable in one module, set as the session
 * ends and taken by the sign-in screen a moment later. Browser storage would
 * do the same job, but `AUTH-5` keeps session state out of it and this needs
 * no exception — the two screens are the same running program, and a flag that
 * dies with the tab is exactly what is wanted. A reload arrives with nothing
 * to announce, which is correct: by then it is not news.
 */
let timedOut = false;

/** The session just ended for being idle. */
export function markTimedOut(): void {
  timedOut = true;
}

/** Whether to explain the sign-in screen — true at most once per sign-out. */
export function takeTimedOut(): boolean {
  const was = timedOut;
  timedOut = false;
  return was;
}
